// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/generation_crop.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/generation_crop.proto.
 */
export const file_vision_generations_v1_generation_crop: GenFile = /*@__PURE__*/
  fileDesc("Cit2aXNpb24vZ2VuZXJhdGlvbnMvdjEvZ2VuZXJhdGlvbl9jcm9wLnByb3RvEhxwcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxIngKDkdlbmVyYXRpb25Dcm9wEgkKAXgYASABKAESCQoBeRgCIAEoARINCgV3aWR0aBgDIAEoARIOCgZoZWlnaHQYBCABKAESMQoLYXNwZWN0X2xvY2sYBSABKAsyHC5nb29nbGUucHJvdG9idWYuRG91YmxlVmFsdWViBnByb3RvMw", [file_google_protobuf_wrappers]);

/**
 * @generated from message protos.vision.generations.v1.GenerationCrop
 */
export type GenerationCrop = Message<"protos.vision.generations.v1.GenerationCrop"> & {
  /**
   * @generated from field: double x = 1;
   */
  x: number;

  /**
   * @generated from field: double y = 2;
   */
  y: number;

  /**
   * @generated from field: double width = 3;
   */
  width: number;

  /**
   * @generated from field: double height = 4;
   */
  height: number;

  /**
   * @generated from field: google.protobuf.DoubleValue aspect_lock = 5;
   */
  aspectLock?: number | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.GenerationCrop.
 * Use `create(GenerationCropSchema)` to create a new message.
 */
export const GenerationCropSchema: GenMessage<GenerationCrop> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_generation_crop, 0);

